import { defaultCampaignId, getCampaign } from './campaigns/index.js'
import getStationColor from './utils/getStationColor.js'

const presentOnly = (object) =>
  Object.fromEntries(Object.entries(object).filter(([, value]) => value != null && value !== ''))

const toNumber = (value) => (value === undefined ? undefined : Number(value))
const toBoolean = (value) => (value === undefined ? undefined : value !== false && value !== 'false')

// Attributes win over URL parameters, which win over the campaign's defaults
export const loadSettings = (attributes) => {
  const requested = {
    ...presentOnly(Object.fromEntries(new URLSearchParams(window.location.search))),
    ...presentOnly(attributes),
  }

  const campaignId = requested.campaignId ?? (requested.stationId ? undefined : defaultCampaignId)
  const campaign = getCampaign(campaignId)
  const stationId = requested.stationId ?? campaign?.dario?.stationId
  const marker = campaign?.map?.marker

  const defaults = {
    campaignId,
    stationId,
    trackerColor: getStationColor(stationId),
    trackerIcon: marker?.icon,
    trackerIconSize: marker?.iconSize,
    trackerAnchor: marker?.anchor,
    maxZoom: campaign?.map?.maxZoom ?? 18,
    padding: 50,
    allowMove: true,
  }
  const settings = { ...defaults, ...requested }

  return {
    ...settings,
    maxZoom: toNumber(settings.maxZoom),
    padding: toNumber(settings.padding),
    zoomDuration: toNumber(settings.zoomDuration),
    allowMove: toBoolean(settings.allowMove),
    sleepingOverlayEnabled: toBoolean(settings.sleepingOverlayEnabled),
  }
}
